<script context="module">
	import {External, M} from "../external";
	import NewCampaignPopup from "../Automation/Popups/NewCampaignPopup.svelte";

	export function createCampaign() {
		if (window.messagingDisabled) {
			External.CPanel.goToUrl("/me/crm/marketing/campaign", true);
			return;
		}
		External.Tools.showWindow({
			width: 645,
			customClass: "add-automation-dialog",
			isModal: false,
			noTitle: true,
			noNav: true,
			withDarkBackground: true,
			forceAtRight: false,
			action: {
				onShow: function (popup, context) {
					popup.bindComponent(
						new NewCampaignPopup({
							target: popup.getContentArea(),
							props: {
								onSelect: (option) => {
									popup.close();
									if (option === "email") {
										External.CPanel.goToUrl("/me/crm/marketing/campaign", true);
									} else if (option === "sms_whatsapp") {
										External.CPanel.goToUrl("/me/crm/marketing/campaign/message", true);
									}
								}
							}
						})
					);
				}
			}
		});
	}
</script>

<script>
	import {onMount} from "svelte";
	import {makeWebsiteRequest, randomInt} from "../Common/tools";
	import Table from "../Table/Table.svelte";
	import MarketingLimitsWarning from "../Common/MarketingLimitsWarning.svelte";
	import {REGULAR, AB_CONTENT, AB_SUBJECT, SMS, WHATSAPP, VOICE, getCRMMessageChannelType} from '../Campaign/static';
	import {getChannelIcon} from "../CRM/Popups/messages/common";

	let tab = "all";
	let subTab = "all";
	let query = "";
  let lastQuery = "";
	let selection = null;
	let moreInstance;
	let loading = false;
	let currentPage = 1;
	let pagesCount = 0;
	let pageSize = 10;

	let helpVideoMarkup = "";

	const columns = [
		{key: "image", type: "image", label: "", class: "flex-none mw-100"},
		{
			key: "name",
			label: M.NAME,
			class: "flex-1 mw-300 ws-normal",
			row: "modified",
			rowLabel: function (row, column) {
				if (row.draft && row.delayTimestamp) {
					return M.SCHEDULED_FOR + " " + External.Tools.dateToString(new Date(row.delayTimestamp.epochSecond * 1000), true, true);
				} else {
					return M.SENT_ON + " " + (row.delayTimestamp ? External.Tools.dateToString(new Date(row.delayTimestamp.epochSecond * 1000), true, true) : row.modified);
				}
			},
			tags: function (row, column) {
				if (row.draft && row.delayTimestamp) return [];
				return [{key: "draft", label: M.DRAFT}];
			}
		},
		{key: "audience", label: M.AUDIENCE, type: "number", class: "mw-100"},
		{
			key: "open",
			label: M.OPENED,
			type: "percent",
			rowClass: function (data, column) {
				return data.messageCampaign ? "pay-status paid dash-content" : "pay-status paid";
			},
			class: "mw-100"
		},
    {
      key: "click",
      label: M.CLICKED,
      type: "percent",
      rowClass: function (data, column) {
        return data.messageCampaign ? "order-status pending dash-content" : "order-status pending";
      },
      class: "mw-100"
    },
    {
      key: "bounce",
      label: M.BOUNCED,
      type: "percent",
      rowClass: function (data, column) {
        return data.messageCampaign ? "order-status pending dash-content" : "order-status pending";
      },
      class: "mw-100"
    },
    {
      key: "spam",
      label: M.SPAM,
      type: "percent",
      rowClass: function (data, column) {
        return data.messageCampaign ? "order-status pending dash-content" : "order-status pending";
      },
      class: "mw-120"
    },
		{
			type: "action",
			action: function (id, action, campaign) {
				if (action === "delete") {
					External.Tools.prompt(M.DEL_CONFIRM, External.escapeFormat(M.DEL_CONFIRM_EXT, "ext", campaign.name), async () => {
						External.Tools.makeWebsiteRequest({
							action: "deleteMarketingCampaign",
							data: {
								id: id
							},
							onOk: function () {
								readCampaigns(0);
							}
						});
					});
				} else if (action === "clone") {
					External.Tools.prompt(M.CLONE_CAMPAIGN, M.ARE_YOU_SURE_CLONE_CAMPAIGN, function () {
						External.Tools.makeWebsiteRequest({
							action: "cloneCampaign",
							data: {
								id: id
							},
							onOk: function () {
								readCampaigns(0);
							}
						});
					});
				}
			},
			items: [
				{text: M.CLONE, icon: "fa-copy", tag: "clone"},
				{text: M.DELETE_TITLE, icon: "fa-trash", tag: "delete"}
			],
			class: "mw-40"
		}
	];

	let data = {
		count: 0,
		columns: columns,
		rows: []
	};

	function switchTab(t) {
		selection = null;
		tab = t;
		data.rows = [];
		readCampaigns(0);
	}

	function switchSubTab(t) {
		selection = null;
		subTab = t;
		data.rows = [];
		readCampaigns(0);
	}

	async function readCampaigns(page, append) {
		if (loading) return;

		loading = true;

		let request = {
				skip: page * 10,
				withStats: subTab !== "drafts"
			},
			filters = {};

		if (tab === "email") {
			filters.types = [REGULAR, AB_CONTENT, AB_SUBJECT];
		} else if (tab === "message") {
			filters.types = [SMS, WHATSAPP, VOICE]; /*Add new message channels here*/
		}

		if (subTab === "drafts") {
			filters.draft = true;
		} else if (subTab === "sent") {
			filters.draft = false;
		}

		if (query !== "") {
			filters.name = query;
		}

		if (Object.keys(filters).length > 0) {
			request.filters = JSON.stringify(filters);
		}

		let response = await makeWebsiteRequest({
			action: "getMarketingCampaigns",
			data: request
		});

		if (!response.data) {
			loading = false;
			return;
		}

		data.count = response.data.count;
		pagesCount = response.data.pagesCount;
		currentPage = page;

		let items = response.data.items;
		items.forEach(function (item) {
			let imageVer = item.modified ? item.modified.epochSecond : randomInt(10000);

			if (item.messageCampaign) {
				item.image = getChannelIcon(getCRMMessageChannelType(item.type));
			} else {
				item.image = item.content != null
					? External.getThumbnailsFromBase("s/" + item.dataDir + "/", "emails") + item.id + ".png?ver=" + imageVer
					: External.resources + "/images/emails/email-placeholder.PNG";
			}

			item.modified = item.modified ? External.Tools.dateToString(new Date(item.modified.epochSecond * 1000), true, true) : "";
			item.audience = item.data && item.data.audience ? item.data.audience : 0;
		});

		if (tab === "message") {
			data.columns = columns.filter(column => ["open", "click", "bounce", "spam"].indexOf(column.key) === -1);  //remove the open, click, spam & bounce columns
			columns.find(column => column.key === "audience").class = "mw-300";                           //increase the width of the audience column
		} else {
			data.columns = columns;
			columns.find(column => column.key === "audience").class = "mw-100";
		}

		loading = false;

		if (append) {
			data.rows = data.rows.concat(items);
		} else {
			data = Object.assign({}, data, {rows: items});
		}
	}

	let onNext = (scrollableBody) => {
		if (loading) return;
		if (data.count === null || currentPage + 1 >= pagesCount) return;
		readCampaigns(currentPage + 1, true);
	};

	function click(row) {
		let url = (row.messageCampaign
			? row.draft ? "/me/crm/marketing/campaign/message?id=" : "/me/crm/marketing/campaign/message/overview?id="
			: row.draft ? "/me/crm/marketing/campaign?id=" : "/me/crm/marketing/campaign/overview?id=") + row.id;

		External.CPanel.goToUrl(url, true);
	}

	function onQuery() {
    if (query === lastQuery) {
      return;
    }
    lastQuery = query;
		search();
	}

	let search = External.$.debounce(250, function () {
		data.rows = [];
		readCampaigns(0);
	});

	function onMoreClick() {
		const target = External.$(moreInstance);
		const items = [{text: M.DELETE_SELECTED, icon: "fa-trash", tag: "delete"}];

		External.Tools.showTooltipOptions(target, items, function (target, idx, text, tag) {
			if (tag === "delete") {
				if (!selection || (!selection.all && (!selection.hasOwnProperty("selected") || selection.selected.length === 0))) {
					External.Tools.showError(M.SELECT_CAMPAIGN_FIRST);
					return;
				}

				External.Tools.prompt(M.DELETE, M.ARE_YOU_SURE_CAMPAIGN, function () {
					External.Tools.makeWebsiteRequest({
						action: "deleteMarketingCampaigns",
						data: {
							selection: JSON.stringify(selection)
						},
						onOk: function () {
							readCampaigns(0);
						}
					});
				});
			}
		});
	}

	onMount(function () {
		readCampaigns(0);
		if (External.Website.onboarding && External.Website.onboarding.marketingCampaigns) {
			helpVideoMarkup = External.CPanel.getEmbedVideo(External.Website.onboarding.marketingCampaigns);
		}
	});
</script>

<div class="account-settings store-products flex-1 horizontal-flex-table col20" style="font-family: 'Roboto';">
	<div class="top-background-wrapper wide-top-background" style="padding-top:30px;">
		<div class="top-background" style="max-width:1200px;">
			<div class="text-wrapper f-left col20 flex align-center space-between mobile-row">
				<div class="flex align-center">
					<div class="flex flex-start flex-col f-left mr-20" style="align-items: baseline;">
						<h2 class="crm-title crm-title-bigger f-left">
							{M.ALL_CAMPAIGNS}
						</h2>
						<h2 class="crm-title f-left mt-5" style="opacity: 0.7;">{data.count} {M.CAMPAIGNS}</h2>
					</div>
					<div class="f-right flex-centered">
						<a class="crm-option" style="padding-right: 33px;" on:click={onMoreClick} bind:this={moreInstance}>
							{M.MORE}
							<svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
								<path d="M4 6l4 4 4-4H4z"/>
							</svg>
						</a>
					</div>
				</div>
				<div>
					<a on:click={createCampaign} class="f-right middle-button blue with-icon" style="height:42px; line-height:42px;">{M.CREATE_CAMPAIGN}</a>
					<div class="col5 f-right mr-10 search-outer-wrapper">
						<input type="text" bind:value={query} on:keyup={onQuery} class="search-input border-type-all" placeholder={M.SEARCH_CAMPAIGN_NAME}/>
						<span class="material-icons"> search </span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="content-wrapper horizontal-flex-table" style="max-width:1200px; width: 94%;">
		<div class="sections-wrapper members-wrapper horizontal-flex-table">
			<div class="section-bg members-wrapper products-wrapper crm-table-outer">
				{#if !window.messagingDisabled}
					<ul class="profile-navigation t-center profile-navigation-centered">
						<li><a class:active={tab === "all"} on:click={() => switchTab("all")}>{M.ALL}</a></li>
						<li><a class:active={tab === "email"} on:click={() => switchTab("email")}>{M.EMAIL}</a></li>
						<li><a class:active={tab === "message"} on:click={() => switchTab("message")}>{M.MESSAGES}</a></li>
					</ul>
				{/if}

				<div class="upper-navigation upper-navigation-full col20 f-left mt-15 mb-25 flex justify-center">
					<ul style="background: #f5f6fa; border-radius: 3px;">
						<li class="upper-navigation-item">
							<a class:active={subTab === "all"} on:click={() => switchSubTab("all")}>{M.ALL}</a>
						</li>
						<li class="upper-navigation-item">
							<a class:active={subTab === "sent"} on:click={() => switchSubTab("sent")}>{M.SENT}</a>
						</li>
						<li class="upper-navigation-item">
							<a class:active={subTab === "drafts"} on:click={() => switchSubTab("drafts")}>{M.DRAFTS}</a>
						</li>
					</ul>
				</div>

				<MarketingLimitsWarning/>

				{#if loading || data.rows.length > 0}
					<Table activeColumns={data.columns} bind:data={data.rows} bind:selection onClick={click} loading={loading} hideHeadOnLoad={true}
								 nextPage={onNext}/>
				{:else if subTab === "all"}
					<div class="col20 f-left getting-started-layout flex">
						<div class="col11 f-left">
							<h4 class="col20 f-left"><span>{M.EMAIL_CAMPAIGNS}</span></h4>
							<h1 class="col20 f-left mt-10 mb-15">{M.EMAIL_CAMPAIGNS_TITLE}</h1>
							<span class="col20 f-left paragraph-text mb-25">{M.EMAIL_CAMPAIGNS_DESCRIPTION}</span>
							<div class="col20 f-left">
								<a on:click={createCampaign} class="blue big-button with-icon">{M.START_A_CAMPAIGN}</a>
							</div>
						</div>
						<div class="col9 f-left justify-center align-center flex">
							{#if helpVideoMarkup}
								<div class="col20 f-left">
									{@html helpVideoMarkup}
								</div>
							{:else}
								<img src={External.staticResource("/images/campaign-image.png")} alt=""/>
							{/if}
						</div>
					</div>
				{:else}
					<div class="text-center col20 f-left" style="padding: 50px 30px 70px 30px; box-sizing: border-box;">
						<h4 class="col20 f-left t-center mb-15">{M.NO_CAMPAIGNS_YET}</h4>
						<div class="col20 f-left t-center">
							<a class="middle-button blue with-icon inline-block f-none" on:click={createCampaign}>
								{M.START_A_CAMPAIGN}
							</a>
						</div>
					</div>
				{/if}
			</div>
		</div>
	</div>
</div>
